import { useGetCalendarEventsQuery } from "@/src/services/api/events/events.hooks";
import { router } from "expo-router";
import { ScrollView, View } from "react-native";
import EventsNextUp from "../../events/right-panel/event-next";
import { LeaderboardWidget } from "./leaderboard-widget";
import { TrendingTagsWidget } from "./trending-tags-widget";
import { UpcomingBirthdaysWidget } from "./upcoming-birthdays-widget";

type RightPanelProps = Readonly<{
  selectedTag?: string | null;
  onTagSelect?: (tag: string | null) => void;
  onLeaderboardSeeAll?: () => void;
}>;

export const RightPanel = ({
  selectedTag,
  onTagSelect,
  onLeaderboardSeeAll,
}: RightPanelProps) => {
  const { data: calendarEvents } = useGetCalendarEventsQuery({
    filter: JSON.stringify({}),
    sort: JSON.stringify({ startTime: 1 }),
    pageNo: 1,
    pageSize: 100,
  });

  return (
    <ScrollView
      className="hidden md:flex md:w-[26%]"
      showsVerticalScrollIndicator={false}
      contentContainerClassName="pb-6"
    >
      <View className="gap-4">
        <LeaderboardWidget onSeeAll={onLeaderboardSeeAll} />
        {/* <TrendingTagsWidget */}
        {/*   selectedTag={selectedTag} */}
        {/*   onTagSelect={onTagSelect} */}
        {/* /> */}
        <EventsNextUp
          events={calendarEvents?.items ?? []}
          onSeeAll={() => router.push("/events")}
          onEventPress={(event) => router.push(`/events/${event.ItemId}`)}
        />
        <UpcomingBirthdaysWidget />
      </View>
    </ScrollView>
  );
};

export default RightPanel;
